import localforage from "localforage";
import { LargeFileStorage } from "./LargeFileStorage";

export const STORE_NAME = "keyvaluepairs";
export const VERSION = 1.0;

// ~ 250KiB
export const NORMAL_STORE_FILE_SIZE_LIMIT = 250 * 1000;

export class FileStorage {
    private instance: LocalForage;
    private _large: LargeFileStorage;

    constructor(private id: string) {
        this._large = new LargeFileStorage(id);
        this.instance = localforage.createInstance({
            name: this.name(),
            storeName: STORE_NAME,
            version: VERSION,
            driver: [
                localforage.INDEXEDDB,
                localforage.WEBSQL,
                localforage.LOCALSTORAGE,
            ],
        });
    }

    name() {
        return `ur_n_${this.id}`;
    }

    destroy() {
        // since IndexedDB is the first DB in driver list, so we are using it's
        // direct API to delete underlying storage otherwise we would not do this
        const name = this.name();

        const req = window.indexedDB.deleteDatabase(name);
        req.onsuccess = () => {
            console.log(`Deleted successfully: ${name}`);
        };

        req.onerror = () => {
            console.log(`Could not delete: ${name}`);
        };

        req.onblocked = () => {
            console.log(
                `Couldn't delete database due to the operation being blocked: ${name}`
            );
        };

        this._large.destroy();
    }

    clear() {
        this.instance.clear();
        this._large.clear();
    }

    get(path: string) {
        return new Promise<{
            path: string;
            value: string;
        }>((resolve, _reject) => {
            this.instance.getItem(path).then((value) => {
                const v = (value as unknown) as string;
                if (this._large.isLarge(v)) {
                    this._large.get(path, v, resolve);
                } else {
                    resolve({ path, value: v });
                }
            });
        });
    }

    set(path: string, contents: string) {
        return new Promise((resolve, _reject) => {
            if (contents.length > NORMAL_STORE_FILE_SIZE_LIMIT) {
                this.instance
                    .setItem(
                        path,
                        this._large.normalPath(path, contents.length)
                    )
                    .then(() => {
                        this._large.set(path, contents, resolve);
                    });
            } else {
                this.instance
                    .setItem(path, contents)
                    .then(() => resolve({ path }));
            }
        });
    }

    remove(path: string) {
        return new Promise((resolve, _reject) => {
            // console.log('FileStorage::remove Large', path)
            this.instance.getItem(path).then((value) => {
                const v = (value as unknown) as string;
                if (this._large.isLarge(v)) {
                    this.instance.removeItem(path).then(() => {
                        this._large.remove(path, v, resolve);
                    });
                } else {
                    this.instance
                        .removeItem(path)
                        .then(() => resolve({ path }));
                }
            });
        });
    }

    keys() {
        return this.instance.keys();
    }

    length() {
        return this.instance.length();
    }
}
